import { css } from '@emotion/css';

export const shortcuts = css`
	font-size: 12px;
	color: #9999a4;
`;
